import { render, staticRenderFns } from "./InformationEventsDetail.vue?vue&type=template&id=6859d193&scoped=true"
import script from "./InformationEventsDetail.vue?vue&type=script&lang=js"
export * from "./InformationEventsDetail.vue?vue&type=script&lang=js"
import style0 from "./InformationEventsDetail.vue?vue&type=style&index=0&id=6859d193&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6859d193",
  null
  
)

export default component.exports